import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { injectIntl } from 'react-intl';
import { fetchServiceProviderStr } from "../actions";
import { formatMessage, AutoSuggestion, withModulesManager } from "@openimis/fe-core";
import { ServiceProviderLabel } from "../utils";
import _ from "lodash";
import {Grid } from "@material-ui/core";
import { PublishedComponent } from "@openimis/fe-core";

const styles = theme => ({
    page: theme.page
});

class ServiceProviderPicker extends Component {

    state = {
        serviceProvider: [],
        edited:{}
    }

    constructor(props) {
        super(props);
        this.selectThreshold = props.modulesManager.getConf("fe-payroll", "ServiceProviderPicker.selectThreshold", 10);
    }

    componentDidMount() {
        this.setState({ serviceProvider: this.props.serviceProvider });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!_.isEqual(prevProps.serviceProvider, this.props.serviceProvider)) {
            this.setState({ serviceProvider: this.props.serviceProvider })
        }
    }

    getSuggestions = str => !!str &&
        str.length >= this.props.modulesManager.getConf("fe-payroll", "schemesMinCharLookup", 2) &&
        this.props.fetchServiceProviderStr(this.props.modulesManager, str);

    debouncedGetSuggestion = _.debounce(
        this.getSuggestions,
        this.props.modulesManager.getConf("fe-payroll", "debounceTime", 800)
    )

    onSuggestionSelected = v => this.props.onChange(v, ServiceProviderLabel(v));

    onClear = () => {
        this.setState(
            { serviceProvider: [] },
            e => this.onSuggestionSelected(null)
        );
    }

    updateAttribute = (k,v)=>{
        this.setState((state) => (
            {
                edited: {...state.edited, [k]:v}
            }),
            e => console.log("STATE" + JSON.stringify(this.state))
        )
    }

    render() {
        const { intl, classes, value, reset,  withLabel = true, label, overview=false,
            readOnly = false, required = false, withNull = true, nullLabel = null, schemeType=null} = this.props;
        const { serviceProvider, edited } = this.state;

        return(
            <Grid container>
                <Grid item xs={12} className={classes.item}>
                    <AutoSuggestion
                        module="payroll"
                        items={serviceProvider}
                        label={!!withLabel && (label || formatMessage(intl, "payroll", "ServiceProviderPicker.label"))}
                        lookup={ServiceProviderLabel}
                        onClear={this.onClear}
                        getSuggestions={this.debouncedGetSuggestion}
                        renderSuggestion={a => <span>{ServiceProviderLabel(a)}</span>}
                        getSuggestionValue={ServiceProviderLabel}
                        onSuggestionSelected={this.onSuggestionSelected}
                        value={value}
                        reset={reset}
                        readOnly={readOnly}
                        required={required}
                        selectThreshold={this.selectThreshold}
                        withNull={withNull}
                        nullLabel={nullLabel || formatMessage(intl, "payroll", "payroll.ServiceProviderPicker.null")}
                    />
            </Grid>
        </Grid>
        )
    }
}

const mapStateToProps = state => ({
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    serviceProvider: state.payroll.serviceProvider,
    edited: state.edited,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ fetchServiceProviderStr }, dispatch);
};

export default withModulesManager(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withTheme(withStyles(styles)(ServiceProviderPicker)))));